<template>
  <div class="was-watched-tag">
    {{ txt }}
  </div>
</template>

<script>
export default {
  name: `WasWatched`,
  computed: {
    wasWatched() {
      if (Array.isArray(this.$store.state.user.history)) {
        if (this.$store.state.user.history.indexOf(this.video) > -1) {
          return true;
        }
      }
      return false;
    },
    txt() {
      if (!this.wasWatched) {
        return "טרם צפית בשיעור זה";
      }
      return "צפית בשיעור זה";
    },
  },
  props: {
    video: String,
  },
};
</script>

<style lang="scss">
.was-watched-tag {
  display: inline-block;
  background: #f9f9f9;
  border: 1px solid #e97975;
  border-radius: 20px;
  color: #e97975;
  padding: 0.2rem 0.5rem;
  font-size: 0.875rem;
  font-weight: bold;
  margin-left: 1rem;
}
</style>

